import Logger from '@eneco/common/log';
import { getEnecoBeXapiSiteApiV1AccountsByAccountNumberPaymentsByPaymentIdPaymentUrl } from '@eneco/dc-be/client';

/**
 * Redirects the user to the payment URL for a given invoice/payment
 * @param accountNumber - The CRM account number
 * @param paymentId - Payment identifier that determines the type of payment:
 * - Single Invoice Payment: Use the invoice ID directly (e.g., "INV-12345")
 * - Payment Plan Slice: Use format "{paymentPlanId}_{sliceStartDate}" where sliceStartDate is in ISO format (e.g., "PP-001_2024-01-15")
 * - Batch Payment (Multiple Invoices): Use comma-separated invoice IDs (e.g., "INV-001,INV-002,INV-003")
 */
export const redirectToPayment = async (accountNumber: string, paymentId: string): Promise<void> => {
  try {
    const { data } = await getEnecoBeXapiSiteApiV1AccountsByAccountNumberPaymentsByPaymentIdPaymentUrl({
      path: {
        accountNumber,
        paymentId,
      },
    });

    const paymentUrl = data?.data?.url;
    if (!paymentUrl) {
      throw new Error('Failed to get payment URL');
    }
    window.location.href = paymentUrl;
  } catch (error) {
    Logger.error('be13oU', 'Failed to get payment URL: ' + error);
  }
};
